import React from 'react';

const OffersPrices = ({ prices, isCollapsed, collapsedItems, id }) =>
  prices.length > 0 && (
    <div className="offers-list-table-cell">
      <ul className="offer-prices-list offer-values-list list-unstyled no-margin">
        {prices.map((price, index) => {
          if (!isCollapsed || index < collapsedItems) {
            return (
              <li className="offer-prices-list-item" key={`offer_prices_${id}_${price.code}`}>
                {price.price} {price.currency}
              </li>
            );
          }
          return null;
        })}
      </ul>
    </div>
  );

export default OffersPrices;
